const { AppError } = require('./AppError');

class ErrorFormatter {
  static format(error, details, originalError) {
    const errorDetails = {};
    // Rewrite context if is a function with params
    if (error.details instanceof Function) {
      errorDetails.details = error.details(details);
    }
    // Set an original error if defined
    if (typeof originalError !== 'undefined') {
      errorDetails.originalError = originalError;
    }
    return new AppError({ ...error, ...errorDetails });
  }

  static formatRemote(statusCode, remoteErrorData, remoteErrorCatalog, unknownError) {
    const error = remoteErrorCatalog.find((catalogError) => catalogError.referenceStatusCode === statusCode);
    const defaultError = remoteErrorCatalog.find((catalogError) => catalogError.default);
    return this.format(error || defaultError || unknownError, remoteErrorData, remoteErrorData);
  }

  static formatRemoteFromCode(referenceErrorCode, remoteErrorData, remoteErrorCatalog, unknownError) {
    const error = remoteErrorCatalog.find((catalogError) => catalogError.referenceErrorCode === referenceErrorCode);
    const defaultError = remoteErrorCatalog.find((catalogError) => catalogError.default);
    return this.format(error || defaultError || unknownError, remoteErrorData, remoteErrorData);
  }
}

module.exports = {
  ErrorFormatter,
};
